import React, { useState, useEffect } from 'react';
import { WifiOff, Clock } from 'lucide-react';
import { getGracePeriodInfo } from '../../services/trialService';

export const OfflineGraceWarning: React.FC = () => {
  const [graceInfo, setGraceInfo] = useState(getGracePeriodInfo());

  useEffect(() => {
    // Update every minute
    const interval = setInterval(() => {
      setGraceInfo(getGracePeriodInfo());
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  // Don't show if online or not within grace period
  if (!graceInfo.withinGracePeriod || navigator.onLine) {
    return null;
  }

  const hoursRemaining = graceInfo.hoursRemaining;
  const minutesRemaining = graceInfo.minutesRemaining % 60;

  return (
    <div className="bg-amber-50 dark:bg-amber-900/20 border-l-4 border-amber-400 p-4 mb-4 rounded-r-lg">
      <div className="flex items-start gap-3">
        <WifiOff className="w-5 h-5 text-amber-600 dark:text-amber-400 flex-shrink-0 mt-0.5" />
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            <p className="text-sm font-medium text-amber-800 dark:text-amber-200">
              Offline Mode
            </p>
            <Clock className="w-4 h-4 text-amber-600 dark:text-amber-400" />
          </div>
          <p className="text-sm text-amber-700 dark:text-amber-300">
            You're using cached access. Please connect to the internet within{' '}
            <span className="font-semibold">
              {hoursRemaining > 0 && `${hoursRemaining}h `}
              {minutesRemaining}m
            </span>{' '}
            to verify your subscription.
          </p>
        </div>
      </div>
    </div>
  );
};
